import { render, staticRenderFns } from "./UserOrganizationsList.vue?vue&type=template&id=2af7c9ea&"
import script from "./UserOrganizationsList.vue?vue&type=script&lang=js&"
export * from "./UserOrganizationsList.vue?vue&type=script&lang=js&"
import style0 from "./UserOrganizationsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports